import { createContext, FunctionComponent, useContext } from 'react';

// Apis
import { getCategories } from '@Libs/api/cms/postCategories';

export interface CategoryItem {
    id?: string;
    slug?: string;
    title?: string;
    color?: string;
    description?: string;
    [key: string]: any;
}

interface Category {
    [key: string]: CategoryItem;
}

interface CategoryContextType {
    categoryObjs: Category;
    categories: Array<CategoryItem>;
}

const initState: CategoryContextType = {
    categories: [],
    categoryObjs: {},
};

const CategoryContext = createContext(initState);

export const useCategory = () => useContext(CategoryContext);

interface ProviderProps {}

export const Provider: FunctionComponent<ProviderProps> = (props) => {
    const { data: categories = [] } = getCategories();

    const categoryObjs = categories?.reduce((obj, item) => {
        obj[item.slug] = { ...item };
        return obj;
    }, {});

    return <CategoryContext.Provider value={{ categoryObjs, categories }}>{props.children}</CategoryContext.Provider>;
};

export function withCategoryStore<T>(WrappedComponent: FunctionComponent<T>): FunctionComponent<T> {
    return ({ ...props }) => (
        <Provider>
            <WrappedComponent {...props} />
        </Provider>
    );
}
